var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiiLogo = function SvgAiiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M31.341 22.81c-8.806 2.909-11.738 5.842-14.648 14.647-.24.724-1.263.724-1.502 0C12.28 28.651 9.349 25.72.543 22.81c-.724-.24-.724-1.263 0-1.502 8.806-2.91 11.738-5.842 14.648-14.648.24-.724 1.263-.724 1.502 0 2.91 8.806 5.843 11.738 14.648 14.648.724.24.724 1.263 0 1.502M37.729 8.348c-4.402 1.453-5.87 2.92-7.325 7.324-.12.363-.631.363-.752 0-1.453-4.401-2.92-5.869-7.325-7.324-.362-.12-.362-.63 0-.752 4.402-1.453 5.87-2.92 7.325-7.325.12-.361.63-.361.752 0 1.453 4.402 2.92 5.87 7.324 7.325.362.12.362.63 0 .752"
  })));
};
export default SvgAiiLogo;